export const fetchPricesApi: string = '/api/v1/billing/fee'